import React from 'react';
import { Phone, Mail, MapPin, Instagram, Twitter, Linkedin, Facebook } from 'lucide-react';
import { CONTACT } from '../mock';

const COLS = [
  {
    title: 'COMPANY',
    links: ['About', 'Careers', 'Press', 'Blog'],
  },
  {
    title: 'DRIVERS',
    links: ['Become a driver', 'Driver app', 'Earnings', 'Support'],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0c] text-white pt-20 pb-10">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] bg-white text-[#0f0f10] text-[10px] font-bold tracking-wider">OTW</span>
              <span className="text-[15px] font-semibold tracking-[0.18em]">ON THE WAY</span>
            </div>
            <p className="mt-4 text-[14px] text-white/55 max-w-xs leading-relaxed">
              India’s friendliest ride, on the way.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Twitter, Linkedin, Facebook].map((Ico, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#FF6A1A] grid place-items-center transition-colors" aria-label="social">
                  <Ico size={15} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <div className="text-[10.5px] font-semibold tracking-[0.18em] text-white/45">{c.title}</div>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-[14px] text-white/75 hover:text-[#FF6A1A] transition-colors">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-4">
            <div className="text-[10.5px] font-semibold tracking-[0.18em] text-white/45">CONTACT</div>
            <ul className="mt-4 space-y-3 text-[14px] text-white/75">
              <li className="flex items-start gap-2.5"><Phone size={15} className="mt-1 text-[#FF6A1A]" /><span>{CONTACT.phone}</span></li>
              <li className="flex items-start gap-2.5"><Mail size={15} className="mt-1 text-[#FF6A1A]" /><span>{CONTACT.email}</span></li>
              <li className="flex items-start gap-2.5"><MapPin size={15} className="mt-1 text-[#FF6A1A]" /><span className="leading-relaxed">{CONTACT.addressLines.join(' ')}</span></li>
            </ul>
            <div className="mt-5 text-[12px] text-white/45">GSTIN: <span className="font-mono">{CONTACT.gstin}</span></div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="text-[12.5px] text-white/45">
            © 2026 ON THE WAY · onthe-way.in · All rights reserved · Made in India
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[12.5px] text-white/55">
            {['Privacy', 'Terms', 'Refunds', 'Cancellation', 'Support'].map((l) => (
              <a key={l} href="#" className="hover:text-[#FF6A1A] transition-colors">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
